import { searchEventUser, saveEventUser, downloadCheckIn } from '@/api';
import { saveAs } from '@/util';
import {
  onMounted, reactive, computed, toRefs,
} from 'vue';
import i18n from '@/i18n';

export default function useCheckIn({
  event,
}) {
  const { t } = i18n.global;
  const form = reactive({
    dniOrEmail: '',
    privacy: false,
    marketingEmails: false,
    rules: {},
    error: false,
    errorCode: '',
    downloadCheckInError: false,
    checkInEventUser: '',
    assistanceConfirmed: false,
  });

  const { marketingEmailsCaption } = toRefs(event);
  const checkMobileView = computed(() => (window.innerWidth < 639));

  const privacyPolicyCaption = computed(
    () => event.privacyPolicyCaption || '[PRIVACY POLICY CAPTION UNDEFINED]',
  );

  const handleFinish = async () => {
    try {
      const user = await searchEventUser(form.dniOrEmail, event.id);
      if (user.id) {
        form.checkInEventUser = user;
      } else {
        form.error = true;
      }
    } catch (e) {
      console.log(e);
    }
  };

  const handleConfirmAssistance = async (eventUser) => {
    try {
      form.checkInEventUser = await saveEventUser({
        eventUser: {
          ...eventUser,
          checkinTime: new Date().toISOString(),
          optInMarketingEmails: form.marketingEmails ? 1 : 0,
        },
        eventId: event.id,
      });
      form.assistanceConfirmed = true;
    } catch (e) {
      form.error = true;
      form.errorCode = e.response.data.error;
    }
  };

  const handleDownloadCheckIn = async () => {
    try {
      form.downloadCheckInError = false;
      const response = await downloadCheckIn({
        eventId: event.id,
        eventUser: form.checkInEventUser,
      });
      saveAs(response.data, `registro_evento_${event.id}.pdf`);
    } catch (e) {
      form.downloadCheckInError = true;
    }
  };

  onMounted(() => {
    form.rules = {
      dniOrEmail: [
        {
          required: true,
          message: '',
          trigger: 'blur',
        },
      ],
      privacy: [
        {
          message: t('components.checkin_view.js.required_privacy_message'),
          trigger: 'blur',
          type: 'enum',
          enum: [true],
        },
      ],
    };
  });

  return {
    form,
    handleFinish,
    checkMobileView,
    privacyPolicyCaption,
    marketingEmailsCaption,
    handleDownloadCheckIn,
    handleConfirmAssistance,
  };
}
